import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Provider, useSelector } from "react-redux";
import store from "../store";
import StatusView from "./StatusView";
import StopView from "./StopView";
import { InfoWindow } from "@react-google-maps/api";
import { useHistory } from 'react-router-dom';

const MapMarker = (props) => {

  const history = useHistory();

  const [mapMarker, setMapMarker] = React.useState(null);
  const { markerData, stopIndex } = props;
  const onLoad = (mapMarker) => {
    setMapMarker(mapMarker);
  };

  const onClick = () => {
    const { isInfoOpen, isSelected, markerData, onClick } = props;

    const isOpen = isSelected ? !isInfoOpen : true;

    onClick(isOpen, markerData.id);
  };

  const renderInfoWindow = (markerId) => {
    const { isInfoOpen, isSelected, markerData } = props;
    // const { mapMarker } = this.state;

    if (!isInfoOpen || !isSelected || !mapMarker) {
      return null;
    }

    return (
      <InfoWindow anchor={mapMarker} zIndex={1}>
      <StopView deviceId={markerData.id} onShowDetails={markerData.stopData} />
      </InfoWindow>
    );
  };
  const label= {color:'white', text:`${stopIndex}`}

  return (
    <Marker
      onLoad={onLoad}
      onClick={onClick}
      position={markerData.position}
      label={label}
      options={{
        icon: {
          url: `images/icon/ban.svg`,
          scaledSize: new window.google.maps.Size(30, 30),
        },
      }}
    >
      {renderInfoWindow(markerData.id)}
    </Marker>
  );
};

const StopsMap = ({ stopDataList }) => {
  const id = "stopDataList";
  const [isInfoOpen, setIsInfoOpen] = React.useState(null);
  const [selectedMarkerId, setSelectedMarkerId] = React.useState(null);

  // const history = useHistory();
  const devices = useSelector((state) => state.devices.items);

  const createFeature = (stopData) => {
    const stopPosition = stopData.stopPosition;
    const device = devices[stopPosition.deviceId] || null;
    return {
      id: stopPosition.deviceId,
      name: device ? device.name : "",
      icon: device && (device.category || "default"),
      position: {
        lat: stopPosition.latitude,
        lng: stopPosition.longitude,
      },
      stopData: stopData
    };
  };

  const onClick = (selectedMarkerId, isInfoOpen) => {
    setIsInfoOpen(isInfoOpen);
    setSelectedMarkerId(selectedMarkerId);
  };

  return (
    <div>
      {stopDataList.map((stopData) => {
        const markerData = createFeature(stopData);
        const {stopIndex} = stopData;
        return (
          <MapMarker
            key={`stops${stopIndex}`}
            markerData={markerData}
            isSelected={stopIndex === selectedMarkerId}
            isInfoOpen={stopIndex === selectedMarkerId && isInfoOpen}
            onClick={()=> onClick(stopIndex, true)}
            stopIndex ={stopIndex}
          />
        );
      })}
    </div>
  );
};

export default StopsMap;
